export class SectionClipboard {
  sourceInspectionId: string;
  sourceSectionId: string;
  selectedItems: { id: string; isFolder: boolean; name: string }[];
  sourceIsOffline: boolean;
  deleteSource: boolean;
}
